import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

/**
 * Destructive-action confirmation, same look as the voucher delete dialog.
 * Small deletes are a plain "Hapus?" confirm; heavy ones pass `confirmText`
 * and the button stays disabled until the admin types it exactly
 * (GitHub-style), so nothing big goes with a single misclick.
 *
 *   <app-confirm-delete *ngIf="del" [title]="..." [subject]="..."
 *       [effects]="[...]" [confirmText]="group.name" [busy]="deleting"
 *       (confirm)="doDelete()" (cancel)="del = null"></app-confirm-delete>
 */
@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.css']
})
export class ConfirmDeleteComponent implements OnChanges {
  @Input() title : string = 'Hapus?';
  /** The thing being deleted, shown in a chip ("ODOJ Keluarga"). */
  @Input() subject : string = '';
  /** What will happen, one line each. */
  @Input() effects : string[] = [];
  /** When set, the admin must type this before the button enables. */
  @Input() confirmText : string = '';
  @Input() actionLabel : string = 'Hapus';
  @Input() busy : boolean = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  typed : string = '';

  ngOnChanges(changes : SimpleChanges){
    if(changes.confirmText){ this.typed = ''; }
  }

  get canConfirm(){
    if(this.busy){ return false; }
    return !this.confirmText || this.typed.trim() === this.confirmText.trim();
  }

  submit(){
    if(this.canConfirm){ this.confirm.emit(); }
  }

  close(){
    if(!this.busy){ this.cancel.emit(); }
  }

  @HostListener('document:keydown.escape')
  onEscape(){ this.close(); }
}
